<template>
    <div v-loading="loading">
        <GainsTable
            :data="gainsData"
        ></GainsTable>
        <CostsForm
            ref="costsForm"
            :costs="costs"
            :initialCosts="simulation.initial_costs"
            @restartSimulation="restartSimulation"
        ></CostsForm>
    </div>
</template>

<script>
import { isEmpty } from 'lodash';
import CostsForm from './CostsForm.vue';
import GainsTable from './GainsTable.vue';
import * as solutions from './constants.js';
    export default {
        name: 'EnergeticGains',
        components: {
            CostsForm,
            GainsTable
        },
        props:{
            simulation:{
                type: Object,
                required: true,
            },
        },
        data(){
            return {
                loading: false,
            }
        },
        computed:{
            costs(){
                return this.simulation.costs_configuration
            },
            gainsData(){
                const solutionMap = {
                    current: solutions.CURRENT_WITH_VARIATOR,
                    ie3_no_variator: solutions.IE3_NO_VARIATOR,
                    ie4_no_variator: solutions.IE4_NO_VARIATOR,
                    msap: solutions.MSAP_WITH_VARIATOR,
                    ie2: solutions.IE2_WITH_VARIATOR,
                    ie3: solutions.IE3_WITH_VARIATOR,
                    ie4: solutions.IE4_WITH_VARIATOR,
                };

                return this.simulation.costs.map((costEntry) => {
                    const gainEuros = this.simulation.gains_euros.find(g => g.switch_motor === costEntry.switch_motor && g.has_variator === costEntry.has_variator).gain_euros || 0;
                    const gainKwh = this.simulation.gains_kwh.find(g => g.switch_motor === costEntry.switch_motor && g.has_variator === costEntry.has_variator).gain_kwh || 0;
                    const gainPercent = this.simulation.gains_percent.find(g => g.switch_motor === costEntry.switch_motor && g.has_variator === costEntry.has_variator).gain_percent || 0;
                    const timeBeforeBenefit = this.simulation.times_before_benefit.find(t => t.switch_motor === costEntry.switch_motor && t.has_variator === costEntry.has_variator);

                    let entry = costEntry.has_variator ? costEntry.switch_motor: costEntry.switch_motor + '_no_variator';

                    const isInRange = timeBeforeBenefit.time_before_benefit >= 0 && timeBeforeBenefit.time_before_benefit < 20;

                    return {
                        solution: solutionMap[entry],
                        costs: costEntry.cost,
                        gains_euros: (gainEuros).toFixed(2),
                        gains_kwh: (gainKwh / 1000).toFixed(2), // Convert to MWh
                        gains_percent: (gainPercent).toFixed(2),
                        times_before_benefit: timeBeforeBenefit && isInRange
                        ? `${Math.round(timeBeforeBenefit.time_before_benefit)} ans (${timeBeforeBenefit.time_before_benefit.toFixed(1)} années)`
                        : 'N/A'
                    };
                }).filter(data => {
                    return data.times_before_benefit !== 'N/A';
                });
            },
            hasCostsConfiguration(){
                return this.simulation 
                && this.simulation.costs_configuration 
                && !isEmpty(this.simulation.costs_configuration);
            }
        },
        
        methods:{
            formatInitialCosts(configuration){
                let initialCosts = {};
                for (const [key, value] of Object.entries(configuration)) {
                    initialCosts[key] = {
                        motor: value.motor,
                        variator: value.variator,
                        installation: value.installation,
                    }
                }
                return initialCosts;
            },
            restartSimulation(data){
                this.loading = true;
                let initialCosts = this.simulation.initial_costs;
                
                if(Object.keys(initialCosts).length === 0){
                    initialCosts = this.formatInitialCosts(this.simulation.costs_configuration);
                }

                this.$store.dispatch('patchItem', {
                    item:{
                        costs_configuration: data,
                        initial_costs: initialCosts,
                        status: 'COSTS_COMPUTE_REQUESTED',
                        uid: this.simulation.uid,
                        url: this.simulation.url
                    },
                    model:'simulations'
                }).then(res => {
                    this.$store.dispatch('fundation/watchRequestStatus',{
                        url: res.url
                    }).then((res) => {
                        this.$notify.success({
                            title: 'Succès',
                            message:'Calcul des gains énergétiques terminé.'
                        });
                        this.$refs.costsForm.resetForm()
                        this.loading = false;
                        this.$emit('refreshSimulation');
                    }).catch((error) => {
                        console.error(e)
                        this.loading = false;
                    });
                }).catch(e => {
                    console.error(e)
                    this.loading = false;
                })
            }
        }
    }
</script>

<style lang="scss">
.simulationOverrides{
    .restart {
        margin-top: 20px;
    }
    .override-form{
        background-color: white;
        display: flex;
        gap:2rem;
        .first-column{
            display: flex;
            .empty-column{
                flex-grow: 1;
            }
            .column-name{
                width:200px;
            }
        }
        .column-name{
            border-bottom: 1px solid #409EFF;
            text-align: center;
            height: 30px;
            margin: 1rem 0;
        }
        .el-form-item{
            display: flex;
            &__label{
                flex-grow: 1;
                margin: 0;
                width: auto;
                margin-right: 20px;
                // height: 40px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                transition: all 0.4s;
                font-weight: 400;
                text-align: left;
            }
        }
    }
    .blueButton {
        border: none;
        text-transform: uppercase;
        font-family: worksans, Arial, "Helvetica Neue", Helvetica, sans-serif;
        box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 5px 0px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 3px 1px -2px;
        background: #409EFF;
        color: white !important;
        padding: 1rem;
        &.is-disabled {
            background: #409EFF;
            opacity: 0.5;
            &:hover {
                background: #409EFF;
                opacity: 0.5;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/partials/EnergeticGains/Index.vue